import { Pagination } from '@shared/ui/pagination';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface PaginationProps {
  pagination: boolean;
  page?: number;
  onPageChange?: (page: number) => void;
  pageCount?: number;
  handlePrevPage: () => void;
  handleNextPage: () => void;
}

export const PaginationFooter = ({
  pagination,
  page,
  onPageChange,
  handleNextPage,
  handlePrevPage,
  pageCount,
}: PaginationProps) => {
  if (!pagination) return;

  return (
    <div {...stylex.props(styles.pagination)}>
      <Pagination
        currentPage={page || 1}
        onPageChange={onPageChange || (() => {})}
        totalPage={pageCount || 1}
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
      />
    </div>
  );
};
